import React, { useState } from 'react';
import {
    Typography,
    Grid,
    Box,
    CssBaseline,
    Container,
    Button,
    TextField,
    useTheme,
    useMediaQuery,
    InputAdornment, 
    IconButton,
} from '@mui/material';
import axios from 'axios';
import { global_link } from '../Components/Globallink';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import backgroundImage from '../Images/callcenter_agent2.png';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const api = axios.create({baseURL: global_link});
  const [formData, setFormData] = useState({});
  const [openUserPass, setOpenUserPass] = useState(false);
  const authToken = process.env.AUTH_TOKEN;
  const [showPassword, setShowPassword] = useState(false);
  const [invalidReason, setInvalidReason] = useState('');

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClosePassAlert = (event, reason) => {
    if (reason === 'clickaway') {return;}
    setOpenUserPass(false);
  }; 

  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal } = state;

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  // const handleLogin = (event) => {
  //   event.preventDefault();
  //   api.post('/auth/login', 
  //     {
  //       email: formData.email,
  //       password: formData.password
  //     }, 
  //     { withCredentials: true })
  //       .then((response) => {
  //         localStorage.setItem(authToken, response.data.token);
  //         const authyToken = localStorage.getItem(authToken);
  //         if (authyToken) {
  //           const headers = {
  //             'Authorization': `Bearer ${authyToken}`,
  //             'Content-Type': 'application/json',
  //           };
  //           api.get('/user/user', { headers, withCredentials: true })
  //             .then(response => {
  //               sessionStorage.setItem("extension", response.data.user_extension);
  //               sessionStorage.setItem("extension_pass", response.data.user_extension_pass);
  //               sessionStorage.setItem("server_url", response.data.server_url);
  //               sessionStorage.setItem("user_level", response.data.user_level);
  //               sessionStorage.setItem("user_name", response.data.user_name);
  //               localStorage.setItem("calldisabled", false);
  //               window.location.href = '/';
  //             });
  //         }
  //       })
  //       .catch((error) => {
  //         setOpenUserPass(true);
  //       });
  // };

  const handleLogin = (event) => {
    event.preventDefault();
    api.post('/auth/login', 
      {
        email: formData.email,
        password: formData.password
      }, 
      { withCredentials: true })
        .then((response) => {
          // Set token with 12-hour expiration
          const expirationTime = new Date();
          expirationTime.setHours(expirationTime.getHours() + 12);
          
          // Store both the token and its expiration time
          localStorage.setItem(authToken, response.data.token);
          localStorage.setItem(`${authToken}_expiration`, expirationTime.toISOString());
          
          const authyToken = localStorage.getItem(authToken);
          if (authyToken) {
            const headers = {
              'Authorization': `Bearer ${authyToken}`,
              'Content-Type': 'application/json',
            };
            api.get('/user/user', { headers, withCredentials: true })
              .then(response => {
                sessionStorage.setItem("extension", response.data.user_extension);
                sessionStorage.setItem("extension_pass", response.data.user_extension_pass);
                sessionStorage.setItem("server_url", response.data.server_url);
                sessionStorage.setItem("user_level", response.data.user_level);
                sessionStorage.setItem("user_name", response.data.user_name);
                localStorage.setItem("calldisabled", false);
                localStorage.removeItem("last_login");
                localStorage.setItem("last_login", new Date().toLocaleString('sv-SE').replace('T', ' '));
                window.location.href = '/';
              });
          }
        })
        .catch((error) => {
          setOpenUserPass(true);
          setInvalidReason(error.response?.data?.error || 'Unable to Connect.');
        });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          bgcolor: 'background.default',
          background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          height: "auto",
        }}
      >

        

<Container maxWidth="xs"      
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      
    }}>

      

                        <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                        <Typography variant="h3" component="h1" sx={{ textAlign:'center', color:'white' }}>
                                        <b>Call Suite CX</b>
                                      </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>

                            <Box
                                sx={{bgcolor:'background.paper',boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px', padding:'20px'}}
                            >

                                 <Typography variant="h5" sx={{textAlign:'center', color:'inherit'}} gutterBottom>
                                    LOGIN
                                </Typography>
                                <form onSubmit={handleLogin}>

<TextField
    placeholder="Email"
    variant="outlined"
    fullWidth
    name="email"
    onChange={handleInputChange}
    margin="normal"
    required
    type='email'
  />

<TextField
    placeholder="Password"
    variant="outlined"
    fullWidth
    name="password"
    onChange={handleInputChange}
    margin="normal"
    required
    type={showPassword ? 'text' : 'password'}
    InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
  />

  <Button
    variant="contained"
    fullWidth
    type="submit"
    color='primary'
    sx={{padding:'10px',marginTop:'12px', }}
    onClick={handleLogin}

  >
    Login
  </Button>
</form>

<Stack spacing={2} sx={{ width: '100%'}}>
            <Snackbar open={openUserPass} autoHideDuration={6000} onClose={handleClosePassAlert}  anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal}>
            <Alert onClose={handleClosePassAlert} severity="error" sx={{ width: '100%' }}>
            {invalidReason}
            </Alert>
            </Snackbar>
            </Stack>

            {/* <Typography sx={{ textAlign: 'center', pt: '15px' }}> <a href="https://noderizon.com" style={{textDecoration: 'none',color: 'white',fontWeight: 'bold',}}
           target="_blank"rel="noopener noreferrer">Powered By Node Rizon</a>
           </Typography> */}
                            </Box>
                        </Grid>
                    </Grid>
                    </Container>

      </Box>
    </>
  );
};

export default Login;